import Vue from 'vue';
import Component from 'vue-class-component';
import {CALLS_EVENTS, COMMAND_TYPE, KICKOUT_TYPE} from '@/components/calls/values/calls.values';
import {Mixins, Prop, Watch, Ref} from 'vue-property-decorator';
import {USER_TYPE} from '@/auth/values/auth.values';
import {CallsService} from '@/components/calls/services/calls.service';
import {CallsSipMixin} from '@/components/calls/services/sip/calls.sip.mixin';
import { showCustomTooltip } from '@/utils/wc-data-table-utils';

@Component({})
export class EdCallsInfoPopupComponent extends Mixins(CallsSipMixin){

    /* Props */
    @Prop() readonly params: any;

    /* Refs */
    @Ref('dataTable') readonly dataTable: any;

    public secs: number = 0;
    public mins: number = 0;
    public hors: number = 0;
    public studentConst: string =  USER_TYPE.STUDENT;
    public teacherConst: string =  USER_TYPE.TEACHER;
    public coteacherConst: string =  'CO_INSTRUCTOR';
    public processing: boolean = false;
    public pagination: object = { page: 1, itemsPerPage: 10, pageCount: 1  };

    get time(){
        let tMin = this.mins.toString();
        let tSec = this.secs.toString();
        if (tMin.length == 1){
            tMin = '0' + tMin;
        }
        if (tSec.length == 1){
            tSec = '0' + tSec;
        }
        return this.hors==0 ? `${tMin}:${tSec}` : `${this.hors}:${tMin}:${tSec}`;
    }

    get membersInfo(){
        return this.$i18n.t('common.memberOfClass',
            { classMembers: this.amountOfUsersInClass, callMembers: this.amountOfUsersOnCall} );
    }

    get amountOfUsersInClass(){
        return this.meet.members.length;
    }

    get amountOfUsersOnCall(){
        let par = this.classMembers.filter(p => p.channelId != null);
        return par ? par.length : 0;
    }

    get members(){
        return this.$store.state.CallsStore.meet.members;
    }

    get users(){
        if(this.isTeacher){
            return this.members.filter(p => p.id !== this.currentUserId);
        }else{
            return this.members;
        }
    }

    get currentUser(){
        return this.members.find(p => p.id === this.currentUserId);
    }

    get isLock(){
        return this.meet.locked;
    }

    get isMute(){
        return this.meet.muted;
    }

    get dataTableCustomStyle(): string {
        return 'border-radius: 4px;';
    }

    /* Hooks */
    created() {
        this.secs = 0;
        this.mins = 0;
        this.hors = 0;
    }
    mounted(){
        this.$edEventBus.$on(CALLS_EVENTS.CALLS_CHANGE_TIME, this.timeChanged);
    }
    unmounted(){
        this.$edEventBus.$off(CALLS_EVENTS.CALLS_CHANGE_TIME, this.timeChanged);
    }

    timeChanged(time:any){
        this.hors = time.hors;
        this.mins = time.mins;
        this.secs = time.secs;
    }

    // Kickout
    canKickout(participant:any){
        return  this.isTeacher &&
            participant.id !== this.currentUserId &&
            participant.type===this.studentConst &&
            participant.channelId != null &&
            !participant.kickouted;
    }

    canUnkickout(participant:any){
        return  this.isTeacher &&
            participant.id !== this.currentUserId &&
            participant.type===this.studentConst &&
            participant.kickouted;
    }

    kickout(participant){
        if(this.processing)return;
        this.processing = true;

        const found = this.classMembers.find(m=>m.id === participant.id)
        const commandType = found.kickouted ? COMMAND_TYPE.UNKICKOUT:COMMAND_TYPE.KICKOUT;

        CallsService.asteriskCommand({ commandType: commandType, meetingId: this.meet.meetingId,
            classId: this.meet.classId, userId:  participant.id, kickoutType: KICKOUT_TYPE.SINGLE_USER })
            .then(() => this.kickOutUserOnCall(participant, commandType, found))
            .catch(e => {
                if (this.userIsNotInCall(e)){
                    this.kickOutUserOnCall(participant, commandType, found);
                }else{
                    this.handleCallError(e);
                }
            })
            .finally(()=> this.processing = false);
    }

    /**
     * Update cache - in or not in a call
     * @param participant
     * @param commandType
     */
    kickOutUserOnCall(participant, commandType, found){
        return CallsService.updateCacheUserCall(this.meet.meetingId, { classId: this.meet.classId, id: participant.id,
                        muted: found.muted, kickouted: !found.kickouted, wasMuted: found.wasMuted})
                .then((meet) => this.spSetMeet(meet))
                .then(() => this.spUpdateLocalStateFromCache())
                .then(() => this.createCallCommand({ commandType, kickUserId: participant.id, className: this.meet.className}))
    }

    // Mute
    canMute(participant:any){
        return this.isTeacher &&
            participant.id !== this.currentUserId &&
          //  (participant.type === this.studentConst || participant.type === this.coteacherConst) &&
                    !participant.kickouted &&
                        participant.channelId != null;
    }

    showMuteIcon(participant:any){
        return !this.isTeacher && participant.channelId != null;
    }

    muteMic(participant){
        if(this.processing)return;
        this.processing = true;
        this.mute(participant.id, true)
            .finally(()=> this.processing = false)
    }


    // Lock
    canLock(){
        return this.isTeacher;
    }

    lock(){
        if(this.processing)return;
        this.processing = true;
        let _this = this;
        _this.meet.locked = !_this.meet.locked;
        const commandType = _this.meet.locked ? COMMAND_TYPE.LOCK:COMMAND_TYPE.UNLOCK;
        let data = {
        }
        CallsService.asteriskCommand({commandType, meetingId: _this.meet.meetingId,
                classId: _this.meet.classId, userId:  _this.currentUserId})
            .then(()=> CallsService.lockCallCache(this.meet.meetingId, { locked: _this.meet.locked }))
            .then((meet)=> _this.spSetMeet(meet) )
            .then(()=> _this.spUpdateLocalStateFromCache())
            .then(()=> _this.createCallCommand({ commandType, locked: _this.meet.locked}))
            .catch(e => this.handleCallError(e))
            .finally(()=> _this.processing = false);
    }

    canMuteMeeting(){
        return this.isTeacher;
    }

    isNotStudent(type){
        return type===this.teacherConst || type===this.coteacherConst;
    }

    muteMeeting(){
        if(this.processing)return;
        this.processing = true;
        this.meet.muted = !this.meet.muted;
        const commandType = this.meet.muted ? COMMAND_TYPE.MUTE_ALL:COMMAND_TYPE.UNMUTE_ALL;
        CallsService.asteriskCommand({ commandType, meetingId: this.meet.meetingId,
                    classId: this.meet.classId, userId: this.currentUserId })
            .then(()=> CallsService.muteCallCache(this.meet.meetingId, {
                        classId: this.meet.classId, userId: this.currentUserId,
                        muted: this.meet.muted, wasMuted: true}))
            .then((meet)=> this.spSetMeet(meet))
            .then(()=> this.spUpdateLocalStateFromCache())
            .then(()=> this.createCallCommand({ commandType, mute: this.meet.muted}))
            .catch(e => this.handleCallError(e))
            .finally(()=> this.processing = false);
    }

    get headers() {
        return [
            { text: 'Actions', value: 'actions', align: 'center' , class: 'colBtn', cellClass: 'colBtn' },
            { text: 'Username', value: 'name',  align: 'left', class: 'colName', cellClass: 'colName' }
        ];
    }

    onPageChange(customEvent: CustomEvent): void {
        const detail: { page: number } = customEvent.detail;
        this.pagination['page'] = detail.page;
        this._loadDataTable();
    }

    private _getItemsPerPage(): any[] {
        const page: number = this.pagination['page'] ?? 1;
        const itemsPerPage: number = this.pagination['itemsPerPage'] ?? 1;
        const index: number = page >= 1 ? page - 1 : 0;
        const start: number = index * itemsPerPage;
        const end: number = start + itemsPerPage;
        return this.users.slice(start, end);
    }

    @Watch('users', { deep: true, immediate: true })
    private _watchUsers(): void {
        const itemsPerPage: number = this.pagination['itemsPerPage'] ?? 1;
        const usersLength: number = this.users?.length ?? 1;
        this.pagination['pageCount'] = Math.ceil(usersLength / itemsPerPage);
        setTimeout(() => {
            this._loadDataTable();
        });
    }

    private _buildItemActionsShowConditions(list: any[]): any[] {
        return list.map((item: {target: string, expression: Function}) => {
            return {
                target: item.target, attribute: 'style', booleanAttribute: false,
                expression: item.expression,
                applied: 'display: inline-flex;', fallback: 'display: none;',
            }
        });
    }

    private _loadDataTable(): void {
        if (!this.dataTable || !this.dataTable.loadData) {
          return;
        }

        if (!this.users || this.users?.length == 0) {
            this.dataTable.loadData({ items: [], headers: this.headers });
            return;
        }

        const slots = {
            'item.actions': {
                template: document.querySelector('#members\\.item\\.actions').innerHTML,
                customTooltip: [
                    {
                        key: 'micTooltip',
                        show: showCustomTooltip(this, (params) => 
                            params.item.muted ? params.parent.$t('common.unmuteCall') : params.parent.$t('common.muteCall')),
                    },
                    {
                        key: 'kickoutTooltip',
                        show: showCustomTooltip(this, (params) => 
                            params.item.kickouted ? params.parent.$t('common.kickouted'): params.parent.$t('common.kick')),
                    },
                ],
                expressions: this._buildItemActionsShowConditions([
                    { target: '.mute-mic',      expression: (params) => params.parent.canMute(params.item) },
                    { target: '.mic-off',       expression: (params) => params.item.muted },
                    { target: '.mic-on',        expression: (params) => !params.item.muted },
                    { target: '.muted',         expression: (params) => params.parent.showMuteIcon(params.item) },
                    { target: '.mic-muted',     expression: (params) => params.item.muted },
                    { target: '.mic-unmuted',   expression: (params) => !params.item.muted },
                    { target: '.can-kickout',   expression: (params) => params.parent.canKickout(params.item) },
                    { target: '.can-unkickout', expression: (params) => params.parent.canUnkickout(params.item) },
                ]),
                events: [
                    { target: '.mute-mic',  handler: (params) => params.parent.muteMic(params.item) },
                    { target: '.kickout',   handler: (params) => params.parent.kickout(params.item) },
                ],
            },
            'item.name': {
                template: document.querySelector('#members\\.item\\.name').innerHTML,
                templateParams: [{
                    key: 'item.fullName',
                    value: (params) => params.item.fullName ?? '',
                }],
                expressions: [
                    {
                      target: '.moderator-call', attribute: 'style', booleanAttribute: false,
                      expression: (params) => params.parent.isNotStudent(params.item.type),
                      applied: 'display: flex;', fallback: 'display: none;',
                    },
                ],
            },
            parent: this,
        };

        this.dataTable.loadData({
            items: this._getItemsPerPage(),
            headers: this.headers,
            slots: slots,
        });
    }
}
export default Vue.component('ed-calls-info-popup', EdCallsInfoPopupComponent);
